import React, { useEffect, useRef, useState } from "react";
import Icon from "../Icon";

import HowItWorks1 from "../../assets/how-it-works-1.png";
import HowItWorks2 from "../../assets/how-it-works-2.png";
import HowItWorks3 from "../../assets/how-it-works-3.png";
import HowItWorks4 from "../../assets/how-it-works-4.png";
import HowItWorks5 from "../../assets/how-it-works-5.png";
import HowItWorks6 from "../../assets/how-it-works-6.png";

export default function HowItWorksSection() {
  const scrollContainerRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const [activeCard, setActiveCard] = useState(0);

  const checkScrollButtons = () => {
    const container = scrollContainerRef.current;
    if (container) {
      setCanScrollLeft(container.scrollLeft > 0);
      const maxScroll = container.scrollWidth - container.clientWidth;
      setCanScrollRight(container.scrollLeft < maxScroll - 1);
    }
  };

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener("scroll", checkScrollButtons);
      checkScrollButtons();
    }
    return () => {
      if (container) {
        container.removeEventListener("scroll", checkScrollButtons);
      }
    };
  }, []);

  const scroll = (direction) => {
    const container = scrollContainerRef.current;
    if (container) {
      const scrollAmount = container.offsetWidth * 0.8;
      const newScrollPosition =
        container.scrollLeft +
        (direction === "right" ? scrollAmount : -scrollAmount);
      container.scrollTo({
        left: newScrollPosition,
        behavior: "smooth",
      });
    }
  };

  const howItWorksCards = [
    {
      id: 1,
      title: "Community Deals",
      description:
        "Tickets of lifestyle-deals met extra korting — exclusief voor onze members. Van events tot sportscholen: wij brengen je aanbod in de groepsapp en zorgen dat het gedeeld wordt zoals alleen vrienden dat doen.",
      imageMobile: HowItWorks1,
      imageDesktop: HowItWorks4,
    },
    {
      id: 2,
      title: "Gastenlijst Activaties",
      description:
        "Soms is bereik niet genoeg — je hebt de juiste mensen nodig op de juiste plek. Wij plaatsen onze community members rechtstreeks op jouw gastenlijst. Niet zomaar een invite: dit zijn mensen die stories delen, hun vriendengroep meenemen en sfeer brengen vanaf minuut één.",
      imageMobile: HowItWorks2,
      imageDesktop: HowItWorks5,
    },
    {
      id: 3,
      title: "Spin & Win",
      description:
        "Onze Spin & Win-activaties zijn gemaakt om aandacht te trekken én conversie te leveren. Members spelen mee om gratis tickets te winnen voor jouw event. Het voelt als een game, maar het effect is serieus: honderden jongeren die direct interactie hebben met je merk of event.",
      imageMobile: HowItWorks3,
      imageDesktop: HowItWorks6,
    },
  ];
  return (
    <div id="how-it-works">
      <section className="md:hidden relative mt-[48px]">
        <div className="flex justify-between items-center pb-[14px]">
          <h1 className="w-full text-[22px] text-white lg:text-[24px] text-start leading-[26px] lg:leading-[36px]">
            Hoe het werkt?
          </h1>

          {/* Navigation Buttons */}
          <div className="flex items-center gap-5 lg:mr-7">
            <button
              onClick={() => scroll("left")}
              disabled={!canScrollLeft}
              className={`p-2 rounded-full shadow-lg transition-all duration-200 bg-white
                  ${
                    canScrollLeft
                      ? "hover:bg-gray-50 lg:cursor-pointer opacity-100"
                      : "cursor-not-allowed opacity-40"
                  }`}
              aria-label="Scroll left"
            >
              <Icon
                icon="heroicons:chevron-left"
                className="w-[20px] h-[20px] text-gray-800"
              />
            </button>
            <button
              onClick={() => scroll("right")}
              disabled={!canScrollRight}
              className={`p-2 rounded-full shadow-lg transition-all duration-200 bg-white
                  ${
                    canScrollRight
                      ? "hover:bg-gray-50 lg:cursor-pointer opacity-100"
                      : "cursor-not-allowed opacity-40"
                  }`}
              aria-label="Scroll right"
            >
              <Icon
                icon="heroicons:chevron-right"
                className="w-[20px] h-[20px] text-gray-800"
              />
            </button>
          </div>
        </div>

        {/* Scroll Container */}
        <div
          ref={scrollContainerRef}
          className="flex gap-6 w-full overflow-x-auto scroll-smooth hide-scrollbar"
          style={{
            scrollSnapType: "x mandatory",
            touchAction: "auto",
            overflowY: "visible",
          }}
        >
          {howItWorksCards
            .sort((a, b) => (a.trending_index || 0) - (b.trending_index || 0))
            .map((card, index) => (
              <div
                key={index}
                className="flex-none py-1 lg:pl-2 w-full md:w-[calc(33.33%-16px)] scroll-snap-align-start"
                style={{
                  scrollSnapAlign: "start",
                  userSelect: "auto",
                  pointerEvents: "auto",
                  touchAction: "auto",
                }}
              >
                <div className="relative bg-[#0B0415D9] p-[24px_20px] border-[#292433] border-[1.5px] rounded-[16px] text-white transition-all duration-300">
                  <div className="mb-4 rounded-[6px] lg:rounded-[8px] w-full max-w-[95vw] max-h-[430px] overflow-hidden">
                    <img
                      src={card.imageMobile}
                      alt={card.title}
                      className="w-full object-cover hover:scale-105 transition-transform duration-300"
                    />
                    <div className="mt-[20px] font-semibold text-[20px] text-white leading-[24px]">
                      {card.title}
                    </div>
                    <div className="mt-[8px] font-normal text-[#EFEDF2] text-[16px] leading-[22px]">
                      {card.description}
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>

        <style>{`
          .hide-scrollbar::-webkit-scrollbar {
            display: none;
          }
          .hide-scrollbar {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }

          /* Fix for mobile vertical scrolling */
          @media (max-width: 768px) {
            .event-content {
              touch-action: auto !important;
              pointer-events: auto !important;
              -webkit-overflow-scrolling: touch !important;
            }

            /* Ensure the body and html can scroll */
            html, body {
              touch-action: auto !important;
              overflow-y: auto !important;
              -webkit-overflow-scrolling: touch !important;
            }

            /* Make sure the container doesn't block vertical scrolling */
            .w-full.flex.overflow-x-auto {
              touch-action: pan-x pan-y !important;
              -webkit-overflow-scrolling: touch !important;
            }
          }
        `}</style>
      </section>
      <section className="max-md:hidden relative my-[96px] w-full">
        <div className="flex flex-col gap-[16px]">
          <div className="font-semibold text-[36px] text-white leading-[36px] tracking-[-1px]">
            Hoe het werkt?
          </div>
        </div>
        <div className="gap-[40px] grid grid-cols-2 mt-[24px]">
          <div className="flex flex-col gap-[64px]">
            {howItWorksCards.map((card, index) => (
              <button
                onClick={() => setActiveCard(index)}
                onMouseEnter={() => setActiveCard(index)}
                key={index}
                className={`border-[#292433] border-[1.5px] rounded-[16px] text-start transition-all duration-200`}
              >
                <div
                  className={`font-semibold text-[22px] leading-[26px] tracking-[-0.5px] transition-all duration-200 ${
                    activeCard === index
                      ? "bg-clip-text bg-gradient-to-r from-[#CAAAF4] to-[#E54098] text-transparent"
                      : "text-white"
                  }`}
                >
                  {card.title}
                </div>
                <div
                  className={`mt-[8px] text-[#EFEDF2] text-[18px] leading-[24px] transition-all duration-200`}
                >
                  {card.description}
                </div>
              </button>
            ))}
          </div>
          <div className="flex justify-center items-center bg-[#0B0415D9] p-[40px] border-[#292433] border-[1.5px] rounded-[16px] w-full h-full">
            <img
              src={howItWorksCards[activeCard].imageDesktop}
              alt={howItWorksCards[activeCard].title}
              className="object-cover"
            />
          </div>
        </div>
      </section>
    </div>
  );
}
